import { Amplify } from 'aws-amplify'
import { config, isConfigured } from '@/lib/config'

/** Configure Amplify Auth once at startup. Safe no-op when env vars are missing (shows a banner instead). */
export function configureAmplify() {
  if (!isConfigured) return
  Amplify.configure({
    Auth: {
      Cognito: {
        userPoolId: config.userPoolId,
        userPoolClientId: config.clientId,
        loginWith: { email: true },
      },
    },
  })
}
